import React from 'react';
import _axios from "../../httpService"
import {prefixUrl} from "../../utils/utilsData";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import {formatToPersianAddComma} from "../../utils/CommaSeparator";

const MyComponent = ({selectedRow, entityName}) => {

  const getData = () => {
    debugger

    debugger
    const id = selectedRow.getData().primaryKey
    _axios.get(prefixUrl() + `/accountingPrint/?request=accountRemaining&entity=${entityName}&id=${id}`).then(res => {
      if (res.data.status) {
        Swal.fire("باقیمانده حساب : " + formatToPersianAddComma(res.data.remaining) + res.data.currency);
      } else {
        toast.error(res.data.message)
      }

    })
  }
  return (
    <>
      <button
        className="btn btnFixedOverWrite"
        onClick={getData}
        disabled={selectedRow === undefined}
      >
        دریافت مقدار مانده
      </button>
    </>
  );
};

export default MyComponent;
